import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";
import { apiFetch } from "../lib/apiClient";
import male1 from "../img/male/men1.jpeg";
import male2 from "../img/male/men2.jpeg";
import male3 from "../img/male/men3.jpeg";
import male4 from "../img/male/men4.jpeg";
import female1 from "../img/female/fem1.jpeg";
import female2 from "../img/female/fem2.jpeg";
import female3 from "../img/female/fem3.jpeg";
import female4 from "../img/female/fem4.jpeg";

const malePlaceholderImages = [male1, male2, male3, male4];
const femalePlaceholderImages = [female1, female2, female3, female4];

const getRandomImage = (images) =>
  images[Math.floor(Math.random() * images.length)] || "";

const isValidEmail = (value = "") => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const isStrongPassword = (password) =>
  password.length >= 8 &&
  /[A-Z]/.test(password) &&
  /\d/.test(password) &&
  /[^A-Za-z0-9]/.test(password);

export default function AuthenticationPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [placeholderImage, setPlaceholderImage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    tel: "",
    whatsapp: "",
    hasDifferentWhatsapp: false,
    location: "",
    sex: "",
    nationality: "",
    ageRange: "",
    password: "",
    confirmPassword: "",
    service: "",
    image: "",
    acceptedTerms: false,
  });
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (name === "sex") {
      if (value === "M") {
        setPlaceholderImage(getRandomImage(malePlaceholderImages));
      } else if (value === "F") {
        setPlaceholderImage(getRandomImage(femalePlaceholderImages));
      } else {
        setPlaceholderImage("");
      }
    }

    setFormData((current) => ({
      ...current,
      whatsapp:
        name === "hasDifferentWhatsapp" && !checked ? "" : current.whatsapp,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files && event.target.files[0];

    if (!file) {
      setFormData((current) => ({
        ...current,
        image: "",
      }));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((current) => ({
        ...current,
        image: typeof reader.result === "string" ? reader.result : "",
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatusMessage("");

    if (!isValidEmail(formData.contact)) {
      setStatusMessage("Please enter a valid email address.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setStatusMessage("Passwords do not match.");
      return;
    }

    if (!isStrongPassword(formData.password)) {
      setStatusMessage(
        "Password must be at least 8 characters and include a capital letter, a number, and a special character.",
      );
      return;
    }

    if (!formData.acceptedTerms) {
      setStatusMessage("Please accept the policy and terms.");
      return;
    }

    setIsSubmitting(true);

    try {
      const imageToSubmit = formData.image || placeholderImage;
      const whatsappToSubmit = formData.hasDifferentWhatsapp
        ? formData.whatsapp
        : formData.tel;

      await apiFetch("/api/auth", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          image: imageToSubmit,
          whatsapp: whatsappToSubmit,
        }),
      });

      setStatusMessage("Account data saved successfully.");
      setFormData({
        name: "",
        contact: "",
        tel: "",
        whatsapp: "",
        hasDifferentWhatsapp: false,
        location: "",
        sex: "",
        nationality: "",
        ageRange: "",
        password: "",
        confirmPassword: "",
        service: "",
        image: "",
        acceptedTerms: false,
      });
      setPlaceholderImage("");
      window.setTimeout(() => {
        navigate("/home");
      }, 3000);
    } catch (error) {
      setStatusMessage(error.message || "Backend not reachable.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="l-container">
      <form className="card" onSubmit={handleSubmit}>
        <h2 className="title">Sign Up</h2>

        <label className="auth-label" htmlFor="name">
          Nickname
        </label>
        <div className="input-group">
          <span className="icon">👤</span>
          <input
            id="name"
            type="text"
            name="name"
            placeholder="Nickname"
            className="input"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <label className="auth-label" htmlFor="contact">
          Contact@
        </label>
        <div className="input-group">
          <span className="icon">👤</span>
          <input
            id="contact"
            type="email"
            name="contact"
            placeholder="E-mail"
            className="input"
            value={formData.contact}
            onChange={handleChange}
          />
        </div>
        <label className="auth-label" htmlFor="tel">
          Telephone Number
        </label>
        <div className="input-group">
          <span className="icon">📞</span>
          <input
            id="tel"
            type="number"
            name="tel"
            placeholder="Telephone Number"
            className="input"
            value={formData.tel}
            onChange={handleChange}
          />
        </div>
        <label className="auth-checkbox auth-checkbox-inline" htmlFor="hasDifferentWhatsapp">
          <input
            id="hasDifferentWhatsapp"
            type="checkbox"
            name="hasDifferentWhatsapp"
            checked={formData.hasDifferentWhatsapp}
            onChange={handleChange}
          />
          <span>WhatsApp *Num is different from tel *Num</span>
        </label>
        {formData.hasDifferentWhatsapp && (
          <>
        <label className="auth-label" htmlFor="whatsapp">
          WhatsApp Number
        </label>
        <div className="input-group">
          <span className="icon">📞</span>
          <input
            id="whatsapp"
            type="number"
            name="whatsapp"
            placeholder="Whatsapp Number"
            className="input"
            value={formData.whatsapp}
            onChange={handleChange}
          />
        </div>
          </>
        )}

        <p>Sex <sup className="text-danger ">*</sup></p>
        <select
          name="sex"
          value={formData.sex}
          onChange={handleChange}
        >
          <option value="">Select</option>
          <option value="M">M</option>
          <option value="F">F</option>
        </select>
        <p>Location <sup className="text-danger ">*</sup></p>
        <select
          name="location"
          value={formData.location}
          onChange={handleChange}
        >
          <option value="">Select your Location</option>
          <option value="Accra, Ghana">Accra, Ghana</option>
          <option value="Tema, Ghana">Tema, Ghana</option>
          <option value="Kasoa, Ghana">Kasoa, Ghana</option>
          <option value="Kumasi, Ghana">Kumasi, Ghana</option>
          <option value="Obuasi, Ghana">Obuasi, Ghana</option>
          <option value="Cape Coast, Ghana">Cape Coast, Ghana</option>
          <option value="Takoradi, Ghana">Takoradi, Ghana</option>
          <option value="Sunyani, Ghana">Sunyani, Ghana</option>
          <option value="Tamale, Ghana">Tamale, Ghana</option>
        </select>

        <p>Nationality<sup className="text-danger ">*</sup></p>
        <select
          name="nationality"
          value={formData.nationality}
          onChange={handleChange}
        >
          <option value="">Select your Nationality</option>
          <option value="Ghanaian">Ghanaian</option>
          <option value="Nigerian">Nigerian</option>
          <option value="Ivorian">Ivorian</option>
          <option value="Kenyan">Kenyan</option>
          <option value="South African">South African</option>
        </select>

        <p>Select Age Range<sup className="text-danger ">*</sup></p>
        <select
          name="ageRange"
          value={formData.ageRange}
          onChange={handleChange}
        >
          <option value="">Choose age range</option>
          <option value="18-24">18-24</option>
          <option value="25-30">25-30</option>
          <option value="31-40">31-40</option>
          <option value="41+">41+</option>
        </select>
           <p>Create Password<sup className="text-danger ">*</sup></p>

        <div className="input-group">
          <span className="icon">🔒</span>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            className="input"
            value={formData.password}
            onChange={handleChange}
            minLength={8}
          />
          <span
            className="toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </span>
        </div>
        <p className="auth-helper-text">
          Password must be at least 8 characters and include a capital letter, a number, and a symbol.
        </p>
        <div className="input-group">
          <span className="icon">🔒</span>
          <input
            type={showPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm Password"
            className="input"
            value={formData.confirmPassword}
            onChange={handleChange}
            minLength={8}
          />
          <span
            className="toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </span>
        </div>

        <p>Choose Service Type<sup className="text-danger ">*</sup></p>
        <select
          name="service"
          id="service"
          value={formData.service}
          onChange={handleChange}
        >
          <option value="">Select a service</option>
            <option value="Tour Guide">Tour Guide</option>
            <option value="Massage">Massage</option>
            <option value="Therapy">Therapy</option>
            <option value="Companion Service">Companion Service</option>
        </select>

        <p>Add Profile Picture<sup className="text-danger ">*</sup></p>
        <input
          type="file"
          accept="image/*"
          className="auth-file-input"
          onChange={handleImageChange}
        />
        {(formData.image || placeholderImage) && (
          <img
            className="auth-image-preview"
            src={formData.image || placeholderImage}
            alt="Selected profile preview"
          />
        )}

        <label className="auth-checkbox" htmlFor="acceptedTerms">
          <input
            id="acceptedTerms"
            type="checkbox"
            name="acceptedTerms"
            checked={formData.acceptedTerms}
            onChange={handleChange}
          />
          <span>I accept the policy and terms.</span>
        </label>

        {statusMessage && <p className="auth-status">{statusMessage}</p>}

        <button className="create-btn mt-3" type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Saving..." : "Create Account"}
        </button>

      </form>
    </div>
  );
}
